module.exports = __webpack_public_path__ + "static/img/payway1.2f58fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway1.png
// module id = Jj/j
// module chunks = 0